import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'focus-visible';

import AOS from 'aos';

import '../../styles/theme.scss';
import '../../styles/theme.scss.liquid';

import $ from 'jquery';
import {focusHash, bindInPageLinks} from '@shopify/theme-a11y';
import {cookiesEnabled} from '../ui/cookies';
import Navigation from '../ui/navigation';
import ProductCard from '../ui/product-card';
import ProductListSlider from '../ui/product-list-slider';
import ProductCardSlider from '../ui/product-card-slider';
import StoreSwitcher from '../ui/store-switcher';
import Accordion from '../ui/accordion';
import Cart from '../ui/cart';
import CookieBar from '../ui/cookie-bar';
import FluidField from '../ui/fluid-field';
import Modal from '../ui/modal';
import {Alert} from '../ui/alert';
import GetColours from '../ui/get-colours';
import Messages from '../ui/messages';
import {NewsletterForm} from '../ui/newsletter-form';
import {wishlistCount} from '../app-extends/wishlist-plus/wishlist-count';
import CaptchaCatcher from '../ui/captcha-catcher';
import '../ui/faq-sidebar';

import '../ui/gtm/gtm-core';
import '../ui/gtm/route-tracking';
import RouteDetector from '../ui/route-detector';
import {storageTracker} from '../ui/utils/storage-tracker';

import {formatMoney} from '@shopify/theme-currency';

window.formatMoney = formatMoney;

import { load } from '@shopify/theme-sections';
import '../sections/top-banner';
import '../ui/predictive-search';
import '../ui/facets';

load('top-banner');

// Common a11y fixes
focusHash();
bindInPageLinks();

new RouteDetector(storageTracker, {
  login: ['account'],
  register: ['register', 'index'],
  addresses: ['addresses'],
});

// Apply a specific class to the html element for browser support of cookies.
if (cookiesEnabled()) {
  document.documentElement.className = document.documentElement.className.replace(
    'supports-no-cookies',
    'supports-cookies',
  );
}

/**
 * Navigation
 */
new Navigation('.megamenu');

/**
 * Wishlist counter
 */
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}

window.SwymCallbacks.push(() => {
  const wishlistCounter = document.querySelector('[data-wishlist-count]');
  wishlistCount(wishlistCounter);
});

/**
 * Switcher
 */
new StoreSwitcher('.store-switcher');


/**
 * Modal
 */
new Modal();

/**
 * Alerts
 */
$('[data-alert]').each((_, alert) => new Alert(alert));

/**
 * Messages
 */
$('.messages').each((_, item) => new Messages(item));

/**
 * Get Variant Colours
 */
$('[data-colours]').each((_, item) => new GetColours(item));

/**
 * Fluid fields
 */
$('.field--fluid').each((_, item) => {
  new FluidField(item);
});

/**
 * Cart
 */
new Cart('[data-cart]');

/**
  * Card Sliders
 */
document.addEventListener('DOMContentLoaded', () => {
  const productCardSliders = document.querySelectorAll('.product-card-slider')
  if (productCardSliders.length > 0) {
    productCardSliders.forEach((productCardSlider) => {
      const productCardSliderElement = new ProductCardSlider(productCardSlider)
      productCardSliderElement.onInit()
    });
  }
});

/**
 * Cards
 */
new ProductCard();

/**
 * Product Sliders
 */
document.addEventListener('DOMContentLoaded', () => {
  const productSliders = document.querySelectorAll('.product-slider')
  if (productSliders.length > 0) {
    productSliders.forEach((productSlider) => {
      const productListSlider = new ProductListSlider(productSlider)
      productListSlider.onInit()
    });
  }
});

/**
 * Cookie Bar
 */
new CookieBar('.cookies');

/**
 * Cookie Bar
 */
new NewsletterForm('[data-newsletter]');

/**
 * Look for unlabelled Google reCaptchas
 */
new CaptchaCatcher();

/**
 * Accordions
 */

$('.footer__links').each((_, item) => {
  new Accordion(item, {
    selectors: {
      item: '.footer-linklist',
      anchor: '.footer-linklist__title',
      list: '.footer-linklist__list',
    },
  });
});

/**
 * DOM loaded decorator for animation fix
 */
function removePreload() {
  $('body').removeClass('preload');
  AOS.init({
    once: true,
  });
}

$(document).ready(removePreload);

/**
 * Decorate lazy load parents
 * @param {Event} event
 */
function decorateLazyParent(event) {
  const {target} = event;

  $(target)
    .closest('.responsive-image__wrapper')
    .addClass('has-loaded');
}

$(document).on('lazyloaded', decorateLazyParent);
